import { render, staticRenderFns } from "./TeamImageDropdown.vue?vue&type=template&id=1061963e"
import script from "./TeamImageDropdown.js?vue&type=script&lang=js&external"
export * from "./TeamImageDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports